import Vue                  from 'vue';
import Vuex                 from 'vuex';
import getters              from './getters';
import actions              from './actions';
import mutations            from './mutations';
import createPersistedState from 'vuex-persistedstate';
import SecureLS             from 'secure-ls';

const ls = new SecureLS({ isCompression: false });

Vue.use(Vuex);

const state = {
    uid: '',
    sessionId: '',
    errorState: '',
    isAuth: false,
    menus: [],
    myPages: [],
    locale: '',
    params: {},
    popupParams: {},
    regParams: {},
    token: '',
    corpCd: '',
    roles: [],
    deptNo: '',
    deptLevelCd: '',
    loginNo: '',
    loginRhq: '',
    loginSystem: '',
    superUserYn: '',
    supportSnb: {},
    supportSnbParams: {},
    connSystem: '',
    returnSystem: '',
    loginId: '',
    countryCd: '',
    countryNm: '',
    corpNo: '',
    corpNm: '',
    companyNo: '',
    joinDate: '',
    lastLogin: '',
    langCd: '',
    guid: '',
    email: '',
    loginCountryCd: '',
};

export default new Vuex.Store({
    plugins: [
        createPersistedState({
            storage: {
                getItem: key => ls.get(key),
                setItem: (key, value) => ls.set(key, value),
                removeItem: key => ls.remove(key),
            },
        }),
    ],
    state,
    mutations,
    getters,
    actions,
});



// WEBPACK FOOTER //
// ./src/vuex/store.js